import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import * as firebase from "firebase";

Vue.config.productionTip = false;

// firebase init goes here
const configOptions = {
    apiKey: "AIzaSyC4-qtRzqsdNUm7EpGBFD0AHRKYwPW7JR4",
    authDomain: "joeradman.firebaseapp.com",
    databaseURL: "https://joeradman.firebaseio.com",
    projectId: "joeradman",
    storageBucket: "joeradman.appspot.com",
    messagingSenderId: "573954946480",
    appId: "1:573954946480:web:12ce010ddcd433e3f09275"
  };

if (!firebase.apps.length) {
  firebase.initializeApp(configOptions);
}


firebase.auth().onAuthStateChanged(user => {
    store.dispatch("fetchUser", user);
  });

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");


